/**
 * Stack AccessiBe above Freshchat, and keep both under site drawers
 * and the country switcher.
 *
 * The visible AccessiBe icon is a shadow button (`part="acsb-trigger"`),
 * not the 0×0 <access-widget-ui> host. Document CSS cannot set its z-index,
 * and position is controlled by the inherited `--offset-top` variable.
 */

const TRIGGER_PART = '[part="acsb-trigger"]'
const STYLE_ID = 'floating-widgets'
const DRAWERS_OPEN_CLASS = 'util-DrawersOpen'
const STORE_SELECTOR_OPEN_CLASS = 'util-StoreSelectorOpen'
const TRIGGER_CSS = '.trigger-button { z-index: 9 !important }'
const GAP_PX = 12
const DEFAULT_OFFSET = '80px'
const FIXED_BAR_OFFSET = '180px'

let scheduled = false

function getOffset () {
  const chat = document.getElementById('fc_frame')
  if (chat) {
    const rect = chat.getBoundingClientRect()
    if (rect.height > 0) {
      return `${Math.round(window.innerHeight - rect.top + GAP_PX)}px`
    }
  }

  const aboveFixedBar =
    document.body.classList.contains('is-FixedBar-visible') &&
    !document.querySelector('.prd-FixedBar[data-drawer-open="true"]')

  return aboveFixedBar ? FIXED_BAR_OFFSET : DEFAULT_OFFSET
}

function syncOffset (host, offset) {
  if (host.style.getPropertyValue('--offset-top') === offset) return
  host.style.setProperty('--offset-top', offset, 'important')
}

function isOverlayOpen () {
  return (
    document.body.classList.contains(DRAWERS_OPEN_CLASS) ||
    document.body.classList.contains(STORE_SELECTOR_OPEN_CLASS)
  )
}

function syncTriggerStyle (root) {
  let style = root.getElementById(STYLE_ID)
  const css = isOverlayOpen() ? TRIGGER_CSS : ''

  if (!style) {
    if (!css) return
    style = document.createElement('style')
    style.id = STYLE_ID
    root.appendChild(style)
  }

  if (style.textContent !== css) style.textContent = css
}

function patchHost (host, offset) {
  const root = host.shadowRoot
  if (!root?.querySelector(TRIGGER_PART)) return

  syncTriggerStyle(root)
  syncOffset(host, offset)
}

function patch () {
  const offset = getOffset()
  document.querySelectorAll('access-widget-ui').forEach(host => {
    patchHost(host, offset)
  })
}

function schedulePatch () {
  if (scheduled) return
  scheduled = true
  window.requestAnimationFrame(() => {
    scheduled = false
    patch()
  })
}

const observer = new MutationObserver(schedulePatch)

observer.observe(document.body, {
  attributes: true,
  attributeFilter: ['class'],
  childList: true,
})

window.addEventListener('resize', schedulePatch)
window.addEventListener('load', schedulePatch)
schedulePatch()
